import { Customer } from './Customer';

/** Item de forma de pagamento no recebimento (múltiplas formas) */
export interface ReceiptPayment {
  paymentMethod: string;
  amount: number;
  reference?: string;
}

export interface AccountsReceivable {
  id: number;
  // Identificação de contrato / banco
  contractNumber?: string;
  ourNumber?: string;
  bankReferenceNumber?: string;

  documentNumber: string;
  documentType: string;
  issueDate: Date | string;
  dueDate: Date | string;
  receiptDate?: Date | string;
  originalAmount: number;
  discountAmount?: number;
  interestAmount?: number;
  fineAmount?: number;
  amountToReceive: number;
  amountReceived?: number;
  status: string;
  category: string;

  // Classificação / plano de contas / unidade
  subcategory?: string;
  bankName?: string;
  unit?: string;

  // Condições de desconto / tipo de recebimento
  discountDays?: number;
  receiptType?: string;

  // Recorrência
  isRecurring?: boolean;
  recurrenceFrequency?: string;
  recurrenceEndDate?: Date | string;

  receiptMethod?: string;
  receiptReference?: string;
  /** Detalhamento por forma de pagamento (quando mais de uma) */
  receiptPayments?: ReceiptPayment[];
  customerId?: number;
  customerName?: string;
  costCenterId?: number;
  costCenterName?: string;
  issuedByStaffId?: number;
  issuedByStaffName?: string;
  receivedByStaffId?: number;
  receivedByStaffName?: string;
  description?: string;
  invoiceNumber?: string;
  saleOrderNumber?: string;
  installmentNumber?: number;
  totalInstallments?: number;
  bankSlipNumber?: string;
  checkNumber?: string;
  daysOverdue: number;
  remainingAmount: number;

  /** Cliente vinculado (pode vir expandido na API para uso em cobrança Asaas) */
  customer?: Customer;

  // Campos de auditoria
  createdAt?: Date | string;
  updatedAt?: Date | string;
  createdBy?: string;
  updatedBy?: string;
}

/** Resposta típica de POST /api/accountsreceivable/batch */
export interface AccountsReceivableBatchCreateResponse {
  count?: number;
  items?: AccountsReceivable[];
  created?: AccountsReceivable[];
}

export interface AccountsReceivableCreate {
  // Identificação de contrato / banco
  contractNumber?: string;
  ourNumber?: string;
  bankReferenceNumber?: string;

  documentNumber: string;
  documentType: string;
  issueDate: Date | string;
  dueDate: Date | string;
  receiptDate?: Date | string;
  originalAmount: number;
  discountAmount?: number;
  interestAmount?: number;
  fineAmount?: number;
  amountToReceive: number;
  amountReceived?: number;
  status: string;
  category: string;

  // Classificação / plano de contas / unidade
  subcategory?: string;
  bankName?: string;
  unit?: string;

  // Condições de desconto / tipo de recebimento
  discountDays?: number;
  receiptType?: string;

  // Recorrência
  isRecurring?: boolean;
  recurrenceFrequency?: string;
  recurrenceEndDate?: Date | string;

  receiptMethod?: string;
  receiptReference?: string;
  receiptPayments?: ReceiptPayment[];
  customerId?: number;
  costCenterId?: number;
  issuedByStaffId?: number;
  receivedByStaffId?: number;
  description?: string;
  invoiceNumber?: string;
  saleOrderNumber?: string;
  installmentNumber?: number;
  totalInstallments?: number;
  bankSlipNumber?: string;
  checkNumber?: string;
}

export interface AccountsReceivableUpdate extends AccountsReceivableCreate {
  id: number;
}

export interface AccountsReceivableFilter {
  customerId?: number;
  status?: string;
  category?: string;
  dueDateFrom?: Date | string;
  dueDateTo?: Date | string;
  amountFrom?: number;
  amountTo?: number;
}

export interface AccountsReceivableSummary {
  totalPending: number;
  totalOverdue: number;
  totalReceived: number;
  totalAmount: number;
  count: number;
}

/** DTO de um pagamento registrado no título (GET /api/accountsreceivable/{id}/payments). */
export interface AccountsReceivablePayment {
  id: number;
  accountsReceivableId: number;
  amount: number;
  paymentMethod: string;
  reference?: string;
  paymentDate: string;
  /**
   * Ciclo de vida do pagamento:
   * - "Pendente"   → agendado/não confirmado, não entra no cálculo do título
   * - "Confirmado" → recebimento efetivo, entra no cálculo
   * - "Cancelado"  → cancelado, histórico preservado, não entra no cálculo
   */
  status?: string;
  costCenterId?: number;
  createdAt?: string;
  createdBy?: string;
}

/** Item para POST /api/accountsreceivable/payments/batch */
export interface AccountsReceivablePaymentBatchItem {
  accountsReceivableId: number;
  amount: number;
  paymentMethod: string;
  paymentDate: string;
  reference?: string;
  costCenterId?: number;
}

/** Resposta do batch de pagamentos */
export interface AccountsReceivablePaymentBatchResponse {
  count: number;
  payments: AccountsReceivablePayment[];
}

/** Cancelamento em lote de pagamentos (soft delete) */
export interface CancelPaymentsBatchRequest {
  paymentIds: number[];
  cancelledBy?: string;
}

export interface CancelPaymentsBatchResponse {
  cancelledPayments: number;
  /** API pode retornar affectedReceivableTitles ou affectedReceivables */
  affectedReceivables?: number;
  affectedReceivableTitles?: number;
}
